import { useState, useEffect } from 'react';

import { DataGridIdentifiers, DatagridPremiumUi } from '../../Interface';
import { dataGridPremiumColumns } from '../../../utils/helper';
import biService from '../../../service/bi.service';

const BiDataSourceReports = ({ refetch, values, viewField, operatorsDisabled }) => {
  const { refetchTable, setRefetchTable } = refetch;
  const { setSelectedValues } = values;

  const [reports, setReports] = useState({ rows: [], rowCount: 0 });
  const [rowSelectionModel, setRowSelectionModel] = useState([]);

  const initialState = {
    filter: {
      filterModel: {
        items: [],
        logicOperator: 'and',
      },
    },
    sorting: {
      sortModel: [{ field: 'name', sort: 'asc' }],
    },
    pagination: {
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    },
    density: 'compact',
  };

  const getList = (gridState) => {
    biService.getBiHeads(gridState).then((data) => {
      setReports(data);
      setRefetchTable(false);
    });
  };

  useEffect(() => {
    if (operatorsDisabled) {
      setRowSelectionModel([]);
    }
  }, [operatorsDisabled]);

  const columns = dataGridPremiumColumns([
    {
      field: 'name',
      type: 'string',
      headerName: 'Alias név',
    },
    {
      field: 'element',
      type: 'string',
      headerName: 'Forrás',
    },
  ]);

  return (
    <div className="flex overflow-hidden m-4">
      <div className="h-full w-full overflow-x-auto">
        <div className="inline-block w-full border-b border-gray-200 align-middle mt-4 overflow-y-auto overflow-x-auto">
          <DatagridPremiumUi
            datagridIdentifier={DataGridIdentifiers.biHead}
            datagridInitialState={initialState}
            dataLoader={getList}
            rows={reports.rows}
            refetch={{ refetchTable, setRefetchTable }}
            rowCount={reports.rowCount}
            columns={columns}
            onRowClick={(rowData) => {
              if (!viewField) return;
              setSelectedValues(rowData.row);
            }}
            paginationAndfilterMode="server"
            onRowSelectionModelChange={(newRowSelectionModel) => {
              setRowSelectionModel(newRowSelectionModel);
            }}
            rowSelectionModel={rowSelectionModel}
            disableRowSelectionOnClick={!viewField}
          />
        </div>
      </div>
    </div>
  );
};

export default BiDataSourceReports;
